import { createFileRoute } from "@tanstack/react-router";
import { SectionHeading } from "../components/SectionHeading";
import { ServiceCard } from "../components/ServiceCard";
import { CtaBand } from "../components/CtaBand";
import { diensten } from "../lib/data";
import { SITE_URL, ogImageDefault, ogImageMeta } from "../lib/seo";

export const Route = createFileRoute("/diensten")({
  head: () => ({
    meta: [
      { title: "Onze diensten — Fedor Timmerwerken" },
      {
        name: "description",
        content:
          "Alle diensten van Fedor Timmerwerken: dakkapellen, aanbouwen, renovaties, kozijnen, vlonders, schuren, dakopbouw en maatwerk in Dordrecht.",
      },
      { property: "og:title", content: "Onze diensten — Fedor Timmerwerken" },
      {
        property: "og:description",
        content:
          "Dakkapellen, aanbouwen, renovaties, kozijnen, vlonders, schuren, dakopbouw en maatwerk.",
      },
      { property: "og:url", content: `${SITE_URL}/diensten` },
      ...ogImageMeta(ogImageDefault, "Dakkapel geplaatst door Fedor Timmerwerken in Dordrecht"),
    ],
    links: [
      { rel: "canonical", href: `${SITE_URL}/diensten` },
      // Eerste kaartafbeelding is de LCP op mobiel — alvast ophalen.
      ...(diensten[0]
        ? [
            {
              rel: "preload",
              as: "image",
              href: diensten[0].imageSrc,
              imageSrcSet: `${diensten[0].imageSrc768} 768w, ${diensten[0].imageSrc} 1200w`,
              imageSizes: "(min-width: 1024px) 400px, (min-width: 640px) 50vw, calc(100vw - 2rem)",
              fetchPriority: "high" as const,
            },
          ]
        : []),
    ],

  }),
  component: DienstenPage,
});

function DienstenPage() {
  return (
    <>
      <div className="py-14 sm:py-20 lg:py-28">
        <div className="container-tight">
          <SectionHeading
            as="h1"
            eyebrow="Onze diensten"
            title="Timmer- en aannemersdiensten in Dordrecht"
            description="Staat jouw idee er niet tussen? Neem gerust contact op — zolang het van hout gemaakt is, denken we graag met je mee."
            align="center"
            className="mx-auto"
          />

          <h2 className="mt-16 text-center font-heading text-2xl font-bold tracking-tight text-foreground">
            Waarmee we je kunnen helpen
          </h2>

          <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">

            {diensten.map((dienst, i) => (
              <ServiceCard
                key={dienst.slug}
                title={dienst.title}
                description={dienst.description}
                imageSrc={dienst.imageSrc}
                imageSrc768={dienst.imageSrc768}
                imageAlt={dienst.imageAlt}
                slug={dienst.slug}
                priority={i === 0}
              />
            ))}

          </div>
        </div>
      </div>

      <CtaBand />
    </>
  );
}
